"use client";

import { useRef } from "react";
import Link from "next/link";

const BP = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

interface HeroVideoProps {
  videoPath: string;
  posterUrl?: string;
  brandName: string;
  brandSlug: string;
  showSlug: string;
  season: string;
  year: number;
  startTime?: number;
}

export default function HeroVideo({ videoPath, posterUrl, brandName, brandSlug, showSlug, season, year, startTime = 15 }: HeroVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleLoadedMetadata = () => {
    if (videoRef.current && startTime > 0) {
      videoRef.current.currentTime = Math.min(startTime, videoRef.current.duration - 1);
    }
  };

  return (
    <div style={{ position: "relative", height: "78vh", overflow: "hidden", borderBottom: "1px solid var(--ink)" }}>
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster={posterUrl}
        onLoadedMetadata={handleLoadedMetadata}
        style={{
          position: "absolute", inset: 0,
          width: "100%", height: "100%",
          objectFit: "cover",
          objectPosition: "center top",
        }}
      >
        <source src={`${BP}/api/video/${videoPath}`} />
      </video>

      {/* Bottom gradient */}
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0, height: "45%",
        background: "linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 100%)",
        pointerEvents: "none",
      }} />

      {/* Caption */}
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0,
        padding: "20px 40px",
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          <div>
            <p style={{
              fontFamily: "var(--font-mono)",
              fontSize: 9,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.5)",
              marginBottom: 6,
            }}>
              {brandName}
            </p>
            <p style={{
              fontFamily: "var(--font-display)",
              fontWeight: 400,
              fontSize: "clamp(28px, 4vw, 52px)",
              letterSpacing: "-0.03em",
              lineHeight: 0.95,
              color: "white",
            }}>
              {season} {year}
            </p>
          </div>
          <Link
            href={`/archive/${brandSlug}/${showSlug}`}
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 10,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.85)",
              textDecoration: "none",
              borderBottom: "1px solid rgba(255,255,255,0.3)",
              paddingBottom: 2,
              whiteSpace: "nowrap",
            }}
          >
            View Show →
          </Link>
        </div>
      </div>
    </div>
  );
}
